// Mock data for Fit Kiwi - Auckland, NZ

export const brand = {
  name: "Fit Kiwi",
  tagline: "Healthy Meal Plan Delivery Service in Auckland",
  phone: "(09) 555 0426",
  whatsapp: "+64 21 555 0426",
  email: "hello@fitkiwi.co.nz",
  city: "Auckland",
  deliveryAreas: [
    "Auckland CBD", "Ponsonby", "Mount Eden", "Newmarket", "Parnell",
    "Epsom", "Remuera", "Ellerslie", "Manukau", "North Shore (Takapuna)",
    "Albany", "Botany", "Papatoetoe", "Onehunga"
  ],
  deliveryDays: "Sunday, Tuesday and Thursday (3-10pm)",
};

export const heroImage = "https://images.unsplash.com/photo-1546069901-ba9599a7e63c?crop=entropy&cs=srgb&fm=jpg&q=85";

export const howItWorks = [
  {
    title: "CHOOSE YOUR MEAL PLAN",
    desc: "Pick a high-protein meal plan designed to support your fitness and health goals. Vegetarian or non-veg, we cater to all.",
    icon: "ClipboardList",
  },
  {
    title: "WE START COOKING",
    desc: "We cook fresh using quality ingredients, measured protein, and controlled oil \u2014 no preservatives.",
    icon: "ChefHat",
  },
  {
    title: "EFFORTLESS ENJOYMENT",
    desc: "No prep. No mess. Healthy, delicious meals delivered fresh so you feel energised every day.",
    icon: "Truck",
  },
];

export const mealTags = [
  "HIGH PROTEIN",
  "VEGETARIAN",
  "TRADITIONAL",
  "CHICKEN",
  "CARB-CONSCIOUS",
];

export const featuredMeals = [
  {
    name: "CHIPOTLE CHICKEN, FRUIT SALAD & SOYABEAN CURRY",
    desc: "chipotle chicken | fajita veggies | lettuce | chipotle sauce",
    image: "https://images.unsplash.com/photo-1567337710282-00832b415979?crop=entropy&cs=srgb&fm=jpg&q=85",
    tag: "HIGH PROTEIN",
  },
  {
    name: "COTTAGE CHEESE CHOWMEIN",
    desc: "grilled paneer | chowmein noodles | roasted veggies",
    image: "https://images.unsplash.com/photo-1585937421612-70a008356fbe?crop=entropy&cs=srgb&fm=jpg&q=85",
    tag: "VEGETARIAN",
  },
  {
    name: "KIWI FRUIT SALAD",
    desc: "kiwifruit | apples | oranges | grapes | seasonal fruits",
    image: "https://images.unsplash.com/photo-1559561724-732dbca7be1e?crop=entropy&cs=srgb&fm=jpg&q=85",
    tag: "CARB-CONSCIOUS",
  },
  {
    name: "BLACK BEAN QUINOA BOWL",
    desc: "seasoned black beans | pineapple | green onions | grape tomatoes | quinoa",
    image: "https://images.unsplash.com/photo-1602881916963-5daf2d97c06e?crop=entropy&cs=srgb&fm=jpg&q=85",
    tag: "VEGETARIAN",
  },
  {
    name: "HERBED PASTA SALAD",
    desc: "seasoned pasta | cannellini beans | green onions | cucumber | house sauce",
    image: "https://images.unsplash.com/photo-1597958792579-bd3517df6399?crop=entropy&cs=srgb&fm=jpg&q=85",
    tag: "CARB-CONSCIOUS",
  },
  {
    name: "TANDOORI CHICKEN THALI",
    desc: "tandoori chicken | jeera rice | dal | seasonal veg | roti",
    image: "https://images.unsplash.com/photo-1542367592-8849eb950fd8?crop=entropy&cs=srgb&fm=jpg&q=85",
    tag: "CHICKEN",
  },
];

export const gallery = [
  "https://images.unsplash.com/photo-1542367592-8849eb950fd8?crop=entropy&cs=srgb&fm=jpg&q=85",
  "https://images.unsplash.com/photo-1567337710282-00832b415979?crop=entropy&cs=srgb&fm=jpg&q=85",
  "https://images.unsplash.com/photo-1559561724-732dbca7be1e?crop=entropy&cs=srgb&fm=jpg&q=85",
  "https://images.unsplash.com/photo-1585937421612-70a008356fbe?crop=entropy&cs=srgb&fm=jpg&q=85",
  "https://images.unsplash.com/photo-1603911036037-6331767f3b3a?crop=entropy&cs=srgb&fm=jpg&q=85",
];

// Pricing (NZD)
// Each plan `id` matches its Stripe `lookup_key` (set up via /app/backend/setup_stripe.py)
export const weeklyPlans = [
  {
    id: "weekly_full",
    name: "Full Day Plan",
    price: 149,
    unit: "/week",
    highlight: true,
    features: [
      "3 Meals Everyday (Monday - Friday)",
      "100-120g of Protein / Day",
      "1 Chicken/Paneer Rice Bowl (38oz, 100g Chicken Breast)",
      "1 Veg Curry + 3 Roti",
      "1 Veg Protein Salad / Breakfast",
      "Free Delivery",
      "Covers 80-90% of your Nutrition Needs",
    ],
  },
  {
    id: "weekly_active_1",
    name: "Active Plan 1",
    price: 125,
    unit: "/week",
    features: [
      "60-70g of Protein / Day",
      "2 Meals Everyday (Monday - Friday)",
      "Chicken/Paneer Rice Bowl (38oz, 100g Chicken Breast)",
      "1 Veg Curry + 3 Roti",
      "Free Delivery",
      "5 Meal Bags / Week",
      "Vegetarian or non-vegetarian option",
    ],
  },
  {
    id: "weekly_active_2",
    name: "Active Plan 2",
    price: 125,
    unit: "/week",
    features: [
      "60-70g of Protein / Day",
      "2 Meals Everyday (Monday - Friday)",
      "1 Chicken/Paneer Rice Bowl (38oz, 100g Chicken Breast)",
      "1 Veg Protein Salad / Breakfast",
      "Free Delivery",
      "5 Meal Bags / Week",
      "Vegetarian or non-vegetarian option",
    ],
  },
  {
    id: "weekly_trial",
    name: "1-Day Trial",
    price: 29,
    unit: "/day",
    features: [
      "100-120g of Protein",
      "1 Chicken/Paneer Rice Bowl",
      "1 Veg Curry and 3 Roti",
      "1 Veg Protein Salad or Breakfast",
      "Free Delivery",
      "1 Meal Bag",
      "Limited to 1 per household",
    ],
  },
];

export const monthlyPlans = [
  {
    id: "monthly_full",
    name: "Full Day Plan",
    price: 569,
    unit: "/4 weeks",
    highlight: true,
    features: [
      "3 Meals Everyday (Monday - Friday)",
      "100-120g of Protein / Day",
      "1 Chicken/Paneer Rice Bowl (38oz, 100g Chicken Breast)",
      "1 Veg Curry + 3 Roti",
      "1 Veg Protein Salad / Breakfast",
      "Free Delivery",
      "5 Meal Bags / Week",
    ],
  },
  {
    id: "monthly_active_1",
    name: "Active Plan 1",
    price: 465,
    unit: "/4 weeks",
    features: [
      "60-70g Protein / Day",
      "2 Meals Everyday (Monday - Friday)",
      "Chicken/Paneer Rice Bowl",
      "1 Veg Curry + 3 Roti",
      "1000-1100 calories",
      "Free Delivery",
      "5 Meal Bags / Week",
    ],
  },
  {
    id: "monthly_active_2",
    name: "Active Plan 2",
    price: 465,
    unit: "/4 weeks",
    features: [
      "60-70g of Protein / Day",
      "2 Meals Everyday (Monday - Friday)",
      "1 Chicken/Paneer Rice Bowl",
      "1 Veg Protein Salad / Breakfast",
      "Free Delivery",
      "5 Meal Bags / Week",
    ],
  },
];

export const familyBundles = [
  {
    id: "family_full",
    name: "Family Full Day",
    oldPrice: 569,
    price: 555,
    unit: "each / 4 weeks",
    features: [
      "Minimum 2 people",
      "100-120g of Protein Per Person",
      "3 Meals Everyday (Mon - Fri)",
      "Chicken/Paneer Rice Bowl per person",
      "1 Veg Curry and 3 Roti per person",
      "1 Veg Protein Salad / Breakfast per person",
      "Free Delivery — Same Address",
    ],
  },
  {
    id: "family_active_1",
    name: "Family Active 1",
    oldPrice: 465,
    price: 455,
    unit: "each / 4 weeks",
    features: [
      "Minimum 2 people",
      "60-70g Protein Per Person Per Day",
      "2 Meals Everyday Per Person",
      "Chicken/Paneer Rice Bowl per person",
      "1 Veg Curry + 3 Roti per person",
      "Free Delivery — Same Address",
    ],
  },
  {
    id: "family_active_2",
    name: "Family Active 2",
    oldPrice: 465,
    price: 455,
    unit: "each / 4 weeks",
    features: [
      "Minimum 2 people",
      "60-70g Protein Per Person Per Day",
      "2 Meals Everyday Per Person",
      "Chicken/Paneer Rice Bowl per person",
      "1 Veg Protein Salad / Breakfast",
      "Free Delivery — Same Address",
    ],
  },
];

export const whyChoose = [
  {
    title: "Health-First Commitment",
    desc: "Every meal includes clearly portioned, fitness-focused 50-100g+ protein so you know exactly what you're eating and protecting long-term health.",
    icon: "HeartPulse",
  },
  {
    title: "No Compromise",
    desc: "Balanced meals with mouthwatering flavours, fresh ingredients and no preservatives. No compromise in taste or health.",
    icon: "Sparkles",
  },
  {
    title: "Wholesome Heritage",
    desc: "Non-greasy cooking and quality you can taste — feel the goodness in every bite, made fresh in Auckland.",
    icon: "Leaf",
  },
];

export const testimonials = [
  {
    name: "Priya S.",
    location: "Mount Eden, Auckland",
    text: "Fit Kiwi has changed my weekday routine completely. The portions are perfect, high in protein, and the flavours remind me of home. I finally stopped skipping lunch!",
    rating: 5,
  },
  {
    name: "James M.",
    location: "Ponsonby, Auckland",
    text: "As someone training 5 days a week, hitting my protein goals used to be a chore. These meals nail it — fresh, tasty and delivered right to my door.",
    rating: 5,
  },
  {
    name: "Anita R.",
    location: "North Shore",
    text: "The variety is brilliant — no repeated meals in a week. My whole family is on the plan now. Worth every dollar.",
    rating: 5,
  },
];

export const faqs = [
  {
    q: "How do I place an order?",
    a: "Visit fitkiwi.co.nz, choose your meal plan, enter your details, and complete payment. Your first delivery will arrive within 2 days from Sun-Fri!",
  },
  {
    q: "What's included in each meal box?",
    a: "It depends on the plan. Full Day Plan includes a Main Bowl + Veg Curry & 3 Rotis + Veg Protein Salad. Active Plans give you 2 meals daily — choose curry & rotis or protein salad. Not sure? WhatsApp us at +64 21 555 0426.",
  },
  {
    q: "What are the nutrition facts?",
    a: "Per daily box (approx): 1100-1700 calories, 50-120g protein, zero industrial preservatives, no artificial chemicals, low-grease preparation. All meals cooked fresh daily in our Auckland kitchen.",
  },
  {
    q: "Where do you deliver?",
    a: "We currently serve Auckland CBD, Ponsonby, Mount Eden, Newmarket, Parnell, Epsom, Remuera, Ellerslie, Manukau, North Shore (Takapuna), Albany, Botany, Papatoetoe and Onehunga.",
  },
  {
    q: "What are your delivery days?",
    a: "We deliver fresh happiness Sunday, Tuesday and Thursday (3-10pm). Total 10 or 15 meals per week — 2 boxes Sunday, 2 boxes Tuesday, and 1 box Thursday.",
  },
  {
    q: "What's the cutoff time for delivery?",
    a: "Order by 10PM the day before your delivery. Sunday → Saturday 10PM. Tuesday → Monday 10PM. Thursday → Wednesday 10PM.",
  },
  {
    q: "What if I'm not home?",
    a: "We'll securely leave your meal bag at your doorstep or specified safe spot.",
  },
  {
    q: "Can I change my meal plan?",
    a: "Yes! Email hello@fitkiwi.co.nz or WhatsApp +64 21 555 0426 for any adjustments.",
  },
  {
    q: "Do your meals contain allergens?",
    a: "Our kitchen handles nuts, gluten and dairy. Though we maintain rigorous standards, customers with severe allergies should exercise personal judgement.",
  },
];
